import * as TokenConfig from "../../helpers/CookieToken";
import { UserTokenKey } from "../../Constants";
import * as UserServices from "../../services/templateServices/UserServices";
import * as ActionServices from "../../services/templateServices/ActionServices";
import * as LoginServices from "../../services/templateServices/LoginServices";
import {
  useAuthStore,
  useUserStore
} from "../../store";
import { useTranslation } from "react-i18next";

export const useUser = () => {
  const { User,setUser } = useUserStore();
  const {  onLogout, clearErrorMessage, onSession  } = useAuthStore();

  const [t] = useTranslation("global");

  //En base PIGNUS(Usuario) logeado  obtenemos la informacion basica del usuario y la guardamos en el context
  //Para poderlo usar dentro de toda la Applicacion si el Pignus es nullo o no esta cargado mostramos error
  const GetUser = async () => {
     const session = JSON.parse(localStorage.getItem(UserTokenKey));
     if (session) {
         TokenConfig.setAuthorizationHeader(session.token);
         const u = session.idUser;
         let IdUser = parseInt(u);
         let User = await UserServices.GetUserItem(IdUser);
         if(!User.errMessage){
          User["Actions"] = await ActionServices.GetActionApplicationUser(
            User.idUser
          ); //Cargamos los permisos a ver visible o invisible elementos del html
          User["Role"] = await UserServices.GetRoleByUser(User.idUser); //Cargamos Roles
          User["Workgroup"] = await UserServices.GetWorkGroupByUser(User.idUser); //Cargamos WorkGroup
          setUser(User); //Agregamos valor del usuario al Redux
         }else {
            const sessionItem = JSON.parse(localStorage.getItem(UserTokenKey));
            if (sessionItem) {
              await Logout({
                refreshToken: `${sessionItem.refreshToken}`,
                idUser: sessionItem.idUser,
              });
            }
            localStorage.removeItem(UserTokenKey);
            onSession(false);
            onLogout("err add user");
            setTimeout(() => {
              clearErrorMessage();
            }, 10);
            setTimeout(() => {
              window.location.reload(true);
            }, 2000);
         }
     
       }
  };

  const Login = async (objLogin) => {
      let res = 0;
      let name = "";
      let id = 0;
      let errMessage = "";
      const Response = await LoginServices.Login(objLogin);
      if(!Response.errorNumber){ //Si Haalgun mensaje de error
          localStorage.setItem(UserTokenKey, JSON.stringify(Response));
          res = 1;
          name = `${Response.name} ${Response.lastName}`;
          id = Response.idUser;
          await GetUser();
      }else {
         errMessage = t(Response.errorMessage);        
      }
      return { res, name, id, errMessage };
  };

  const Session = async (user) => {
    let res = 0;
    let name = "";
    let id = 0;
    let errMessage = "";
    const Response = await LoginServices.Session(user);
    if(!Response.errorNumber){ //Si Haalgun mensaje de error
      localStorage.setItem(UserTokenKey, JSON.stringify(Response));
      res = 1;
      name = `${Response.name} ${Response.lastName}`;
      id = Response.idUser;
      await GetUser();
    } else {
      errMessage = t(Response.errorMessage);
    }
    return { res, name, id, errMessage };
  };

  const Logout = async (user) => {
    const Response = await LoginServices.Logout(user);
    return Response;
  };


  const RequestPasswordChange = async (User,IC) => {
    const response = await UserServices.RequestPasswordChange(User,IC);
    return response;
  };

  const UpdatePasswordFromRecover = async (values) => {
    let Result;
    const AjaxObj = {
        token: values.token,
        password: values.password,
    };
    Result = await UserServices.UpdatePasswordFromRecover(AjaxObj);
    return Result;
  };


  const GetCompanyByUser = async (idUser) => {
    const response = await UserServices.GetCompanyByUser(idUser);
    return response;
  };

  const GetApplicationByUser = async (idUser) => {
    if(!idUser) return []
    const response = await UserServices.GetApplicationByUser( idUser );
    return response;
  }

  return {
    //Properties
    User,
    //Methods
    GetUser,
    Login,
    Session,
    Logout,
    RequestPasswordChange,
    UpdatePasswordFromRecover,
    GetCompanyByUser,
    GetApplicationByUser,
  };
};
